<template>
  <div>
    <b-overlay :show="showOverlay" class="b-overlay-app" rounded="sm">
      <h3>Motifs de clôture </h3>
      <div
        v-if="!motifSelected"
        class="icon-list"
        v-bind:class="{ 'width-100': isWidth100 }"
      >
        <div
          v-for="motif in motifs"
          :key="motif.id"
          class="amsom-button"
          @click="setMotif(motif)"
        >
          <button class="btn btn-secondary">
            <i :class="fontawesomeico(motif.id)"></i>
          </button>
          <span class="amsom-button-libelle">{{ motif.libelle }}</span>
        </div>
      </div>
      <div v-else>
        <div>
          <button class="btn btn-secondary" @click="unsetMotif">
            <i :class="fontawesomeico(motifPicked.id)"></i>
            {{ motifPicked.libelle }}
          </button>
          <div class="m0 p0">
            <small class="form-text text-muted"
              >Cliquer pour revenir à la selection</small
            >
          </div>
        </div>
        <hr />
        <div class="form-group shadow-textarea">
          <h3>Message de clôture</h3>
          <textarea
            id="details"
            class="form-control z-depth-1"
            name="details"
            placeholder="Entrez un message de clôture..."
            rows="3"
            v-model="message"
          ></textarea>
        </div>

        <button class="btn btn-success" @click="cloturer">Envoyer</button>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: "MotifsCloture",
  data() {
    return {
      selectedMotif: null,
      motifPicked: null,
      showOverlay: false,
      message: "",
    };
  },
  methods: {
    ...mapActions('motifCloture', ['loadMotifsFromAPI']),
    ...mapActions('sollicitations', ['updateSollicitation', 'closeSollicitation', 'reloadSingleSollicitation']),
    setMotif(motif) {
      this.motifPicked = motif;
    },
    unsetMotif() {
      this.motifPicked = null;
    },
    fontawesomeico(motifId) {
      // Retourne une classe d'icône FontAwesome basée sur l'ID du motif
      const iconMap = {
        1: 'fas fa-check',
        2: 'fas fa-times',
        3: 'fas fa-exclamation',
        4: 'fas fa-question',
      };
      return iconMap[motifId] || 'fas fa-circle';
    },
    async cloturer() {
      this.showOverlay = true;
      await this.closeSollicitation(
        {
          sollicitationID: this.sollicitationID,
          codePec: this.$store.getters['user/getCodePec'],
          closeMotifId: this.motifPicked.id,
          closeMsg: this.message
        }
      );
      this.reloadSingleSollicitation(this.sollicitationID);
      this.redirectToSollicitation();
      this.showOverlay = false;
    },
    redirectToSollicitation() {
      this.$router.push({ name: "fichesuivi", params:{id : this.sollicitationID}})
    },
  },
  computed: {
    ...mapGetters('motifCloture', ['getAllMotifs']),
    ...mapGetters('sollicitations', ['selectedSollicitation']),

    sollicitationID() {
      return this.selectedSollicitation;
    },
    isWidth100() {
      if (this.motifs && this.motifs.length < 4) return true;
      return false;
    },
    motifs() {
      return this.getAllMotifs;
    },
    motifSelected() {
      return this.motifPicked ? true : false;
    },
  },
  async mounted() {
    await this.loadMotifsFromAPI();
    if (this.motifs && this.motifs.length === 1) {
      this.setMotif(this.motifs[0]);
    }
  },
};
</script>

<style scoped></style>